import { Button, Flex, Form, Row } from 'antd';
import { useAppDispatch } from 'app/hooks';
import { NumberInput } from 'components/common/FormItem/FormItems';
import React, { useEffect } from 'react';
import { useAddCreditLimitMutation } from '../api/creditLimitApi';
import { IPostCreditLimit } from '../type/CreditLimit.interface';
import { setCommonModal } from 'common/slices/modalSlice';

type Props = {
  selectedRowKeys: React.Key[];
  setSelectedRowKeys: React.Dispatch<React.SetStateAction<React.Key[]>>;
};

const CreditLimitBulkUpdate = ({ selectedRowKeys, setSelectedRowKeys }: Props) => {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();

  const [addCreditLimit, { isSuccess, isLoading }] = useAddCreditLimitMutation();

  const finished = (e: any) => {
    const body: IPostCreditLimit[] = selectedRowKeys?.map((item) => ({
      client_id: item as number,
      client_credit_limit: e.client_credit_limit,
    }));

    addCreditLimit(body);
  };

  useEffect(() => {
    if (isSuccess) {
      dispatch(setCommonModal({ show: false }));
      setSelectedRowKeys([]);
    }
  }, [isSuccess]);

  return (
    <>
      <Form form={form} onFinish={finished} layout='vertical'>
        <Row gutter={[0, 0]}>
          <NumberInput
            name={'client_credit_limit'}
            placeholder='Provide credit limit'
            label='Credit limit'
            required
            size={24}
          />
        </Row>

        <Flex justify='end'>
          <Button loading={isLoading} htmlType='submit' type='primary'>
            Submit
          </Button>
        </Flex>
      </Form>
    </>
  );
};

export default CreditLimitBulkUpdate;
